<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="createDefinition"
  >
    <v-card>
      <v-card-title primary-title>
        Skapa definition
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model.number="model.train_number_from"
                type="number"
                label="Tågnummer från"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                filled
                v-model.number="model.train_number_to"
                type="number"
                label="Tågnummer till"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="model.train_group"
                :items="trainGroups"
                filled
                label="Tåg grupp"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                filled
                label="Definition"
                v-model="model.definition_text"
                placeholder="Definitions text"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row v-if="errors.length">
            <v-col>
              <p class="error--text" v-for="(error, $i) in errors" :key="$i">
                {{ error }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingCreate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingCreate">
          Skapa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'

export default {
  name: 'DefinitionCreate',

  data: () => ({
    pendingCreate: false,
    rules,
    valid: true,
    trainGroups: ['P', 'R'],
    model: {
      train_number_from: 1,
      train_number_to: 2,
      train_group: 'P',
      definition_text: ''
    }
  }),

  computed: {
    ruleTrainNumberFrom() {
      return this.model.train_number_from > this.model.train_number_to
        ? 'Tågnummer från måste vara lägre eller samma än tågnummer till'
        : false
    },

    ruleTrainNumberTo() {
      return this.model.train_number_to < this.model.train_number_from
        ? 'Tågnummer till måste vara högre eller samma än tågnummer från'
        : false
    },

    errors() {
      return [this.ruleTrainNumberFrom, this.ruleTrainNumberTo].filter(Boolean)
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async createDefinition() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.errors.length) return

      this.pendingCreate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation createDefinition($payload: CreateDefinitionInput!) {
            createDefinition(payload: $payload) {
              id
            }
          }
        `,

        variables: {
          payload: {
            ...this.model
          }
        }
      })

      this.pendingCreate = false
      this.$emit('confirm')
    }
  }
}
</script>
